import Advertise from './Advertise';

export default Advertise;
